import { observer } from 'mobx-react-lite';
import {
  Button,
  Pagination,
  PromiseContainer,
  TextField,
} from '../../../../../components';
import { useStore } from '../../../../../store';
import Query from '../../../../../store/utils/query/Query';
import { onSuccess } from '../../../../../utils/errors';
import PulseKeys from '../../../../pulse-keys/store/PulseKeys';

export default observer(function UnusedKeys({
  query,
}: {
  query: Query<any, PulseKeys>;
}) {
  return (
    <PromiseContainer empty={false} promise={query.promise}>
      {(unusedKeys) => <Component query={query} unusedKeys={unusedKeys} />}
    </PromiseContainer>
  );
});

const Component = observer(function Component({
  query,
  unusedKeys,
}: {
  query: Query<any, PulseKeys>;
  unusedKeys: PulseKeys;
}) {
  const { pulseKeyStore } = useStore();

  const count = unusedKeys.items.length;

  async function onExportClick() {
    unusedKeys.exportAll();
    onSuccess(`${count} key${count === 1 ? '' : 's'} exported`);
    query.execute();
  }

  async function onMarkDistributedClick() {
    await pulseKeyStore.markKeysDistributed(unusedKeys.items);
    onSuccess(`${count} key${count === 1 ? '' : 's'} marked as distributed`);
    query.execute();
  }

  return (
    <>
      <TextField
        disabled
        helperText={
          unusedKeys.isEmpty ? null : (
            <Pagination query={query} rowsText="Keys per page" />
          )
        }
        InputLabelProps={{ shrink: true }}
        label="Unused Keys"
        multiline
        placeholder="You have no unused keys"
        rows={5}
        sx={{ mt: 0 }}
        value={unusedKeys.toString()}
        variant="outlined"
      />

      {!unusedKeys.isEmpty && (
        <div>
          <Button
            icon="save"
            onClick={onExportClick}
            size="small"
            sx={{ mt: 1 }}
            type="primaryText"
          >
            Export to file
          </Button>
          <Button
            icon="copy"
            onClick={unusedKeys.copyAllToClipboard}
            size="small"
            sx={{ mt: 1 }}
            type="primaryText"
          >
            Copy to clipboard
          </Button>
          <Button
            icon="check"
            onClick={onMarkDistributedClick}
            size="small"
            sx={{ mt: 1 }}
            type="primaryText"
          >
            Mark distributed
          </Button>
        </div>
      )}
    </>
  );
});
